export default __webpack_public_path__ + "static/media/city.3f94023c.mp3";